const renderCustomCSS = () => {
    const rows = document.getElementsByClassName("ds-custom-css-row");
    const drive_service_divs = window.DriveServiceSpecials.drive_service_divs;
    for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const parent = drive_service_divs.find(
            (div) =>
                div.id === parseInt(row.parentElement.id.replace("ds-div-", ""))
        );
        const rowData = parent.div_rows.find(
            (rowObj) => rowObj.id === parseInt(row.id)
        );
        const { content } = rowData;
        let newContent = content.replaceAll("\n", "");
        newContent = newContent.replaceAll("\t", "");
        const style = document.createElement("style");
        style.innerText = newContent;
        style.id = "ds-row-" + rowData.id + "-custom-styles";
        document.head.append(style);
    }
};

if (process.env.REACT_APP_ENVIRONMENT !== "local") renderCustomCSS();
window.renderCustomCSS = renderCustomCSS;
export default renderCustomCSS;
